<template>
    <div>
        <b-card>
            <b-button variant="primary" @click="addModalOpen = true" v-if="(upravnik === 'habit' && $hasPermissions($permissions.EditHabitVlozisce)) || (upravnik === 'staninvest' && $hasPermissions($permissions.EditStaninvestVlozisce))">Dodaj novo</b-button>
            <Table ref="table" class="mt-1" :fields="fields" v-if="tokenLoaded" route="/api/iiportal-admin/v1/mapirana_vlozisca">
                <template #cell(actions)="row" v-if="(upravnik === 'habit' && $hasPermissions($permissions.EditHabitVlozisce)) || (upravnik === 'staninvest' && $hasPermissions($permissions.EditStaninvestVlozisce))">
                    <div class="d-flex justify-content-center">
                        <b-button class="mr-1" variant="warning" @click="openVlozisceEdit(row.item)"><fa icon="edit"/></b-button>
                        <b-button @click="removeVlozisce(row.item.id)" variant="danger"><fa icon="trash"/></b-button>
                    </div>
                </template>
            </Table>
        </b-card>

        <b-modal v-model="addModalOpen" centered title="Dodaj aktivno vložišče" hide-footer no-close-on-backdrop>
            <b-form>
                <b-form-group label="Osnovno vložišče">
                    <Select v-model="addObject.id_vlozisca" :options="allVlozisa" label="naziv" reduceField="id" text="Osnovno vložišče"></Select>
                </b-form-group>
                <b-form-group label="Naziv">
                    <b-form-input v-model="addObject.novo_ime" placeholder="Prikazan naziv"/>
                </b-form-group>
                <b-form-group class="text-right">
                    <b-button variant="secondary" @click="addVlozisce">Dodaj</b-button>
                </b-form-group>
            </b-form>
        </b-modal>

        <b-modal v-model="editModalOpen" centered title="Uredi aktivno vložišče" hide-footer no-close-on-backdrop>
            <b-form>
                <b-form-group label="Osnovno vložišče">
                    <Select v-model="editObject.id_vlozisca" disabled :options="allVlozisa" label="naziv" reduceField="id" text="Osnovno vložišče"></Select>
                </b-form-group>
                <b-form-group label="Naziv">
                    <b-form-input v-model="editObject.novo_ime" placeholder="Prikazan naziv"/>
                </b-form-group>
                <b-form-group class="text-right">
                    <b-button variant="warning" @click="editVlozisce">Shrani</b-button>
                </b-form-group>
            </b-form>
        </b-modal>
    </div>
</template>
<script>

    import {BModal, BCard, BButton, BForm, BFormGroup, BFormInput} from 'bootstrap-vue'
    import Select from '@/views/Components/Select'
    import Table from '@/views/Components/Table'

    export default {
        components: {
            BModal,
            BCard,
            BButton,
            BForm,
            BFormGroup,
            BFormInput,
            Select,
            Table
        },
        data() {
            return {

                allVlozisa: [],
                mapiranaVlozisca: [],

                tokenLoaded: false,

                fields: [
                    { key: 'originalno_ime', label: 'Osnovno vložišče', sortable: true, class: 'text-center' },
                    { key: 'novo_ime', label: 'Prikazan naziv', sortable: true, class: 'text-center' }
                ],

                addModalOpen: false,
                addObject: {
                    id_vlozisca: '',
                    novo_ime: ''
                },

                editModalOpen: false,
                editObject: {}

            }
        },
        methods: {
            openVlozisceEdit(item) {
                this.editObject = JSON.parse(JSON.stringify(item))
                this.editModalOpen = true
            },
            async loadData() {
                try {

                    this.tokenLoaded = false
                    this.allVlozisa = []
                    this.mapiranaVlozisca = []
                    this.addObject = {
                        id_vlozisca: '',
                        novo_ime: ''
                    }

                    await this.$http.post(`/api/management/v1/login_manager/${  this.upravnik}`)

                    this.tokenLoaded = true

                    const allVloziscaRes = await this.$http.get('/api/iiportal-admin/v1/vlozisca')
                    this.allVlozisa = allVloziscaRes.data

                    const mapiranaVloziscaRes = await this.$http.get('/api/iiportal-admin/v1/mapirana_vlozisca')
                    this.mapiranaVlozisca = mapiranaVloziscaRes.data
                } catch (e) {
                    this.$printError(e)
                }

            },
            async addVlozisce() {
                try {

                    await this.$http.post('/api/iiportal-admin/v1/mapirana_vlozisca', this.addObject)
                    this.addModalOpen = false
                    await this.loadData()

                } catch (e) {
                    this.$printError(e)
                }
            },
            async editVlozisce() {
                try {

                    await this.$http.put(`/api/iiportal-admin/v1/mapirana_vlozisca/${  this.editObject.id}`, this.editObject)
                    this.editModalOpen = false
                    await this.loadData()

                } catch (e) {
                    this.$printError(e)
                }
            },
            async removeVlozisce(id) {
                try {

                    await this.$http.delete(`/api/iiportal-admin/v1/mapirana_vlozisca/${  id}`)
                    await this.loadData()

                } catch (e) {
                    this.$printError(e)
                }
            }
        },
        computed: {
            upravnik() {
                return this.$route.meta.upravnik
            }
        },
        watch: {
            '$route.meta.upravnik'() {
                this.loadData()
            }
        },
        mounted() {
            this.loadData()

            if ((this.upravnik === 'habit' && this.$hasPermissions(this.$permissions.EditHabitVlozisce)) || (this.upravnik === 'staninvest' && this.$hasPermissions(this.$permissions.EditStaninvestVlozisce))) {
                this.fields.push({ key: 'actions', label: '', class: 'text-center' })
            }
        }
    }
</script>